<!-- eslint-disable vue/no-unused-vars -->
<template>
  <div class="home-padding pb-60 text-whitebase">
    <div class="text-2xl font-bold mt-10">Settings</div>
    <div
      class="mt-4 flex justify-between items-end pb-4 border-b border-white-010"
    >
      <div class="flex gap-4 items-center">
        <div
          v-for="(label, i) in ['Profile', 'Notification']"
          class="
            w-31.5
            h-10
            border
            rounded-lg
            flex
            items-center
            justify-center
            cursor-pointer
          "
          :class="{
            ' border-inputActive bg-inputActive': selectedTab === i,
            'border-whitebase': selectedTab !== i,
          }"
          :key="i"
          @click="updateTab(i)"
        >
          <span
            class="icon iconfont mr-2"
            :class="{
              'icon-renshu': label === 'Profile',
              'icon-tixing-01': label === 'Notification',
            }"
          ></span
          >{{ label }}
        </div>
      </div>
      <div v-if="state.userInfo?.addr">
        <span class="underline">
          {{ formatAddress(state.userInfo.addr, 5) }}
        </span>
        <span
          class="icon iconfont cursor-pointer ml-1"
          @click="
            () => {
              if (copy(state.userInfo.addr)) {
                notify({
                  text: 'Copied',
                });
              }
            }
          "
          >&#xe66b;</span
        >
      </div>
    </div>
    <div class="mt-6" v-if="selectedTab === 0">
      <div class="relative flex items-center">
        <div
          class="relative rounded-lg p-px-2 cursor-pointer hover:opacity-80"
          :class="{
            'bg-white-005 hover:bg-white-010': !state.userInfo.bannerUrl,
          }"
          :style="{ width: 1200 + 'px', height: 280 + 'px' }"
        >
          <div
            class="
              w-full
              h-full
              overflow-hidden
              flex
              justify-center
              items-center
              rounded-lg
            "
            @click="selectFile"
          >
            <div v-if="state.loading" class="lds-ripple">
              <div></div>
              <div></div>
            </div>
            <div
              v-else-if="!state.userInfo.bannerUrl"
              class="flex flex-col justify-center items-center"
            >
              <div
                class="
                  rounded-full
                  bg-white-010
                  w-16
                  h-16
                  flex
                  justify-center
                  items-center
                "
              >
                <i class="iconfont icon-bianji text-xl"></i>
              </div>
              <div class="mt-4 font-bold">Profile Banner</div>
              <div class="mt-4 text-white-040 text-xs text-center">
                Recommended 1200px x 280px<br />
                File types Supported: JPG, PNG, GIF, SVG.<br />Max size: 100 M
              </div>
            </div>
            <img
              v-else
              :src="state.userInfo.bannerUrl"
              alt="member image"
              style="width: 1200px; height: 280px"
            />
            <input
              type="file"
              class="w-0 h-0"
              ref="fileInput"
              accept="image/*"
              @change="doUpload"
            />
          </div>
        </div>
      </div>
      <div class="flex gap-6 mt-6">
        <div class="w-1/2 flex flex-col gap-6">
          <div>
            <div>Profile Image</div>
            <PhotoUpload
              v-model="state.userInfo.avatarUrl"
              :size="96"
              name="profile avatar"
            ></PhotoUpload>
          </div>

          <UiInput
            ref="nameInput"
            label="Name"
            v-model="state.userInfo.name"
            placeholder="Enter Name"
            :maxLength="60"
            :rules="['normalStr']"
            :hasDeleteIcon="false"
          ></UiInput>
          <UiTextarea
            :hasDeleteIcon="false"
            ref="introInput"
            description="Share more about yourself and enhance your chances of being discovered!"
            label="Brief"
            v-model="state.userInfo.description"
            placeholder="Enter Brief"
            rows="6"
          ></UiTextarea>
          <div>
            <div class="font-bold">Skills</div>
            <div class="text-xs text-white-070 mb-2">
              Choose your skills to enable others to discover you by filtering
              for specific expertise.
            </div>
            <Multiselect
              v-model="state.userInfo.skills"
              :options="skillOptions"
              mode="tags"
              :close-on-select="false"
              :hideSelected="false"
              placeholder="Select"
              :searchable="true"
              :create-option="true"
              ><template #option="{ option }">
                <div class="flex items-center justify-between w-full">
                  <div
                    :class="{
                      'text-xs rounded-lg bg-white-010 px-2 py-1.5':
                        !option.disabled,
                    }"
                  >
                    {{ option.label }}
                  </div>
                  <span
                    v-if="state.userInfo.skills?.includes(option.label)"
                    class="icon iconfont icon-gou"
                  ></span></div></template
            ></Multiselect>
          </div>
          <div>
            <div class="font-bold">Tag</div>
            <div class="text-xs text-white-070 mb-2">
              Kindly choose your areas of interest to better facilitate
              opportunity discovery and recommendations.
            </div>
            <Multiselect
              v-model="state.userInfo.tag"
              :options="tagOptions"
              mode="tags"
              :close-on-select="false"
              :hideSelected="false"
              placeholder="Select"
              :searchable="true"
              :create-option="true"
              ><template #option="{ option }">
                <div class="flex items-center justify-between w-full">
                  <div
                    :class="{
                      'text-xs  rounded-lg bg-white-010 px-2 py-1.5':
                        !option.disabled,
                    }"
                  >
                    {{ option.label }}
                  </div>
                  <span
                    v-if="state.userInfo.tag?.includes(option.label)"
                    class="icon iconfont icon-gou"
                  ></span></div
              ></template>
            </Multiselect>
          </div>
        </div>
        <div class="w-1/2 flex flex-col gap-6">
          <div>
            <div class="font-bold">Social</div>
            <div class="text-xs text-white-070 mb-2">
              Make it easy for other users to reach you faster
            </div>
            <div
              class="
                px-4
                py-3
                flex
                justify-between
                border-b border-white-010
                mb-4
              "
            >
              <div class="text-base">Twitter</div>
              <div class="flex gap-4">
                <div
                  v-if="state.userInfo.twitter"
                  class="
                    font-bold
                    text-xs
                    py-0.5
                    px-2
                    rounded-lg
                    bg-white-010
                    cursor-pointer
                    flex
                    items-center
                  "
                  @click="state.userInfo.twitter = ''"
                >
                  <span
                    class="icon iconfont icon-guanbi mr-1 flex items-center"
                    style="width: 8px; height: 8px; font-size: 8px"
                  ></span>
                  {{ state.twitter }}
                </div>
                <!-- TODO twitter verification -->
                <div
                  v-if="!state.userInfo.twitter"
                  class="
                    text-xs
                    font-bold
                    rounded-lg
                    bg-inputActive
                    px-4
                    py-0.5
                    cursor-pointer
                    flex
                    justify-center
                    items-center
                  "
                  @click="handleTwVerify"
                >
                  Connect
                </div>
              </div>
            </div>
            <div class="pl-4 flex flex-col gap-4">
              <div class="flex justify-between items-center">
                <div>Discord</div>
                <UiInput
                  :hasDeleteIcon="false"
                  v-model="state.userInfo.discord"
                  class="ml-2 flex-1 w-full"
                  placeholder="Discord"
                  boxStyle="input-boxstyle"
                  style="max-width: 490px; height: 56px"
                ></UiInput>
              </div>

              <div class="flex justify-between items-center">
                <div>Telegram</div>
                <UiInput
                  :hasDeleteIcon="false"
                  v-model="state.userInfo.telegram"
                  class="ml-2 flex-1 w-full"
                  placeholder="Telegram"
                  boxStyle="input-boxstyle"
                  style="max-width: 490px; height: 56px"
                ></UiInput>
              </div>
              <div class="flex justify-between items-center">
                <div>Mirror</div>
                <UiInput
                  :hasDeleteIcon="false"
                  v-model="state.userInfo.mirror"
                  class="ml-2 flex-1 w-full"
                  placeholder="Mirror"
                  boxStyle="input-boxstyle"
                  style="max-width: 490px; height: 56px"
                ></UiInput>
              </div>
              <div class="flex justify-between items-center">
                <div>Website</div>
                <UiInput
                  :hasDeleteIcon="false"
                  v-model="state.userInfo.website"
                  class="ml-2 flex-1 w-full"
                  placeholder="Website"
                  boxStyle="input-boxstyle"
                  style="max-width: 490px; height: 56px"
                ></UiInput>
              </div>
              <div class="flex justify-between items-center">
                <div>Email</div>
                <UiInput
                  :hasDeleteIcon="false"
                  v-model="state.userInfo.email"
                  class="ml-2 flex-1 w-full"
                  placeholder="Email"
                  boxStyle="input-boxstyle"
                  style="max-width: 490px; height: 56px"
                ></UiInput>
              </div>
            </div>

            <div class="pl-4 flex justify-between items-start mt-4">
              <div class="py-4">For More</div>
              <div>
                <div
                  v-for="(link, j) in state.userInfo.customizeLink"
                  :key="j"
                  class="flex flex-col gap-4"
                  style="max-width: 488px"
                >
                  <div class="flex mb-4 relative gap-4">
                    <UiInput
                      v-model="state.userInfo.customizeLink[j].name"
                      class="flex-1"
                      placeholder="Name"
                      boxStyle="input-boxstyle"
                      style="width: 150px; max-width: 150px"
                    ></UiInput>

                    <UiInput
                      v-model="state.userInfo.customizeLink[j].url"
                      class="ml-2 flex-1"
                      placeholder="URL"
                      boxStyle="input-boxstyle"
                      style="width: 324px; max-width: 324px"
                    ></UiInput>

                    <div
                      v-if="j > 0"
                      class="absolute -right-1 -top-1 cursor-pointer"
                      @click="delPlatform(j)"
                    >
                      <i class="iconfont icon-guanbi text-xs"></i>
                    </div>
                  </div>
                  <div
                    v-if="state.userInfo.customizeLink.length - 1 === j"
                    class="
                      w-16
                      h-8
                      rounded
                      bg-mb-red
                      font-bold
                      text-xs
                      flex
                      items-center
                      justify-center
                      cursor-pointer
                      mt-2
                    "
                    @click="addPlatform()"
                  >
                    <i class="iconfont icon-tianjia-46 text-xs"></i> Add
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="selectedTab === 0"
      class="w-full fixed bottom-16 rounded-lg bg-white mt-14"
      style="max-width: 1200px; z-index: 50"
    >
      <div class="flex rounded-lg justify-end p-2 bg-white-010">
        <div
          class="
            py-2
            px-7
            bg-whitebase
            rounded-lg
            text-white
            font-bold
            cursor-pointer
          "
          :class="{ 'cursor-not-allowed opacity-40': !canSave }"
          @click="doSave()"
        >
          SAVE
        </div>
      </div>
    </div>
    <div
      v-if="selectedTab === 1"
      class="flex flex-col gap-6"
      style="max-width: 690px"
    >
      <div class="mt-6">
        <div class="font-bold text-xl">Notification</div>
        <div class="text-xs text-white-070">
          Feel free to select DAOs and members you'd like to follow here, and
          customize your content notifications accordingly.
        </div>
      </div>
      <div class="flex justify-between items-center">
        <div class="flex gap-2 p-2 rounded-lg bg-white-005 w-max">
          <div
            v-for="(button, i) in ['DAO', 'Member']"
            :key="i"
            class="px-4 py-2 font-bold rounded cursor-pointer"
            :class="{
              'bg-inputActive ': state.currNotifType === i,
              'text-white-070': state.currNotifType !== i,
            }"
            @click="handleNotifTypeUpdate(i)"
          >
            {{ button }}
          </div>
        </div>
        <div
          class="
            h-10
            rounded-lg
            text-center
            py-2
            px-4
            bg-inputActive
            font-bold
            cursor-pointer
          "
          @click="handleDialogOpen(state.currNotifType)"
        >
          Add {{ state.currNotifType === 0 ? 'DAOs' : 'Members' }}
        </div>
      </div>
      <div
        class="bg-white-002 rounded-lg py-5 text-center text-white-040"
        v-if="
          (state.currNotifType === 0 &&
            (state.notifList?.followingDAOs?.length < 1 ||
              !state.notifList?.followingDAOs?.length)) ||
          (state.currNotifType === 1 &&
            (state.notifList?.followingMembers?.length < 1 ||
              !state.notifList?.followingMembers?.length))
        "
      >
        {{
          `Click the button below to add your favorite ${
            state.currNotifType === 0 ? 'DAO' : 'Member'
          } to your collection ~`
        }}
      </div>

      <div v-else>
        <div v-if="state.currNotifType === 0">
          <div
            v-for="(item, i) in state.notifList.followingDAOs"
            :key="i"
            class="
              py-3
              px-4
              flex
              justify-between
              items-center
              hover:bg-white-010
              border-b border-white-010
            "
          >
            <div class="flex gap-2 items-center">
              <span
                @click.stop="handleNotifFollow(item)"
                class="icon iconfont cursor-pointer"
                :class="{
                  'icon-shoucangxuanzhong-01 text-added': item.isAdded,
                  'icon-shoucangmoren-01': !item.isAdded,
                }"
              ></span>
              <UiImg
                class="w-8 h-8 rounded-full mr-2"
                :src="item.logo"
                alt="search result logo"
              />
              <div class="text-sm font-bold">
                {{ formatAddress(item.name || item.address, 15) }}
              </div>
            </div>
            <div class="flex gap-10 items-center">
              <div>{{ item.events.length }} Reminders</div>
              <div
                class="
                  cursor-pointer
                  rounded-lg
                  border
                  py-2
                  px-4
                  border-whitebase
                "
                @click="handleNotifDialogOpen(state.currNotifType, item)"
              >
                Notification
              </div>
            </div>
          </div>
        </div>
        <div v-if="state.currNotifType === 1">
          <div
            v-for="(item, i) in state.notifList.followingMembers"
            :key="i"
            class="
              py-3
              px-4
              flex
              justify-between
              items-center
              hover:bg-white-010
              border-b border-white-010
            "
          >
            <div class="flex gap-2 items-center">
              <span
                @click.stop="handleNotifFollow(item)"
                class="icon iconfont cursor-pointer"
                :class="{
                  'icon-shoucangxuanzhong-01 text-added': item.isAdded,
                  'icon-shoucangmoren-01': !item.isAdded,
                }"
              ></span>
              <UiImg
                class="w-8 h-8 rounded-full mr-2"
                :src="item.logo"
                alt="search result logo"
              />
              <div class="text-sm font-bold">
                {{ formatAddress(item.name || item.address, 15) }}
              </div>
            </div>
            <div class="flex gap-10 items-center">
              <div>{{ item.events.length }} Reminders</div>
              <div
                class="
                  cursor-pointer
                  rounded-lg
                  border
                  py-2
                  px-4
                  border-whitebase
                "
                @click="handleNotifDialogOpen(state.currNotifType, item)"
              >
                Notification
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="mt-6">
        <div class="font-bold">Notification Email</div>
        <div class="text-xs text-white-070 mb-2">
          This email is used to receive notifications of content related to the
          DAO and members you are following.
        </div>
        <div class="flex items-center gap-4">
          <UiInput
            class="w-full"
            ref="nameInput"
            label=""
            v-model="state.userInfo.notificationEmail"
            placeholder="Enter Email"
            :maxLength="60"
            :rules="['normalStr']"
            :hasDeleteIcon="false"
            :readonly="state.userInfo.isEmailVerified && !state.editNotifEmail"
          >
            <template #trailing>
              <div
                v-if="state.userInfo.notificationEmail"
                class="pr-4 flex items-center"
              >
                <div
                  v-if="
                    !state.userInfo.isEmailVerified || !state.isEmailVerified
                  "
                  class="
                    flex
                    items-center
                    gap-2
                    text-sm
                    font-bold
                    text-white-040
                  "
                >
                  <img
                    class="rounded-full w-3.5 h-3.5"
                    src="@/assets/icons/neutral.png"
                  />
                  unverified
                </div>
                <div
                  v-if="state.userInfo.isEmailVerified && state.isEmailVerified"
                  class="flex items-center text-sm font-bold gap-2 text-success"
                >
                  <img
                    class="rounded-full w-3.5 h-3.5"
                    src="@/assets/icons/success.png"
                  />
                  Verified
                </div>
              </div></template
            >
          </UiInput>
          <div
            class="
              h-12
              rounded-lg
              flex
              justify-center
              items-center
              bg-inputActive
              w-max
              whitespace-nowrap
              px-4
              py-3
              font-bold
              cursor-pointer
            "
            @click="handleEmailVerification"
            :class="{
              'opacity-40 cursor-not-allowed':
                !maybeValidEmail(state.userInfo.notificationEmail) ||
                remainingTime > 0,
            }"
          >
            {{
              remainingTime > 0
                ? `${remainingTime}s`
                : state.userInfo.isEmailVerified
                ? state.editNotifEmail
                  ? 'Send Verification'
                  : 'Modify'
                : 'Send Verification'
            }}
          </div>
        </div>
        <div
          class="text-xs text-white-070 mt-2"
          v-if="
            (!state.userInfo.isEmailVerified &&
              state.origEmail !== '' &&
              state.origEmail &&
              state.userInfo.notificationEmail !== '' &&
              state.userInfo.notificationEmail) ||
            state.sentVerif
          "
        >
          {{
            `Please check ${state.userInfo.notificationEmail} and verify your new email address. `
          }}
        </div>
      </div>
    </div>
  </div>
  <AddNotifDialog
    :show="state.openDialog"
    :handleClose="handleClose"
    :type="state.dialogType"
  />
  <NotifTypeDialog
    :show="state.openNotifDialog"
    :handleClose="handleNotifClose"
    :type="state.NotifType"
    :item="state.NotifItem"
  />
  <!-- <VerifyEmail
    :show="state.openVerifyEmailDialog"
    :handleClose="handleEmailVerifyClose"
  /> -->
</template>
<script setup>
import { useRoute } from 'vue-router';
import {
  onMounted,
  watch,
  reactive,
  computed,
  ref,
  registerRuntimeCompiler,
} from 'vue';
import {
  getProfile,
  getNotifList,
  notifFollow,
  updateProfile,
  sendEmail,
  twProfileVerify,
} from '@/api/dao';
import { formatAddress } from '@/utils';
import copy from 'copy-to-clipboard';
import { notify } from '@kyvg/vue3-notification';
import PhotoUpload from '@/views/CreateFlow/component/PhotoUpload.vue';
import UiInput from '@/views/CreateFlow/component/UiInput.vue';
import UiTextarea from '@/views/CreateFlow/component/UiTextarea.vue';
import Multiselect from '@vueform/multiselect';
import { useRouter } from 'vue-router';
import AddNotifDialog from './AddNotifDialog.vue';
import UiImg from '@/components/UiImg.vue';
import { uploadImg } from '@/libs/upload';
import UiDropdown from '@/views/CreateFlow/component/UiDropdown.vue';
import NotifTypeDialog from './NotifTypeDialog.vue';
import VerifyEmail from './VerifyEmail.vue';
import { useUserInfo } from '@/hooks';

import { cloneDeep, isEqual } from 'lodash';
const userInfo = useUserInfo();
const fileInput = ref(null);
const router = useRouter();
const $route = useRoute();
const { back } = $route.query;

const state = reactive({
  userInfo: {
    avatarUrl: '',
    name: '',
    description: '',
    skills: [],
    tag: [],
    email: '',
    discord: null,
    telegram: null,
    mirror: null,
    website: null,
    customizeLink: [
      {
        name: '',
        url: '',
      },
    ],
  },
  origEmail: '',
  isEmailVerified: false,
  currNotifType: 0,
  dialogType: '',
  NotifType: '',
  openDialog: false,
  openNotifDialog: false,
  openVerifyEmailDialog: false,
  verifyTwitter: false,
  twitter: '',
  originalInfo: {},
  editNotifEmail: false,
  sentVerif: false,
});
const tagOptions = [
  { label: 'Suggested Tag', value: 'null', disabled: true },
  { label: 'DAO', value: 'DAO' },
  { label: 'Web3', value: 'Web3' },
  { label: 'Defi', value: 'Defi' },
  { label: 'NFT', value: 'NFT' },
  { label: 'Dex', value: 'Dex' },
  { label: 'Cex', value: 'Cex' },
  { label: 'Swap', value: 'Swap' },
  { label: 'Governance', value: 'Governance' },
  { label: 'Aggregator', value: 'Aggregator' },
  { label: 'Investment', value: 'Investment' },
  { label: 'Creations', value: 'Creations' },
];
const socialTypes = [
  { label: 'Website', value: 'Website' },
  { label: 'Discord', value: 'Discord' },
  { label: 'Telegram', value: 'Telegram' },
  { label: 'Mirror', value: 'Mirror' },
];
const skillOptions = [
  { value: 'null', label: 'Suggested Skills', disabled: true },
  { value: 'Development', label: 'Development' },
  { value: 'Design', label: 'Design' },
  { value: 'Translation', label: 'Translation' },
  { value: 'Writing', label: 'Writing' },
  { value: 'Marketing', label: 'Marketing' },
  { value: 'Community', label: 'Community' },
  { value: 'Product', label: 'Product' },
  { value: 'Research', label: 'Research' },

  //   { name: 'Development', value: 'Development' },
  //   { name: 'Design', value: 'Design' },
  //   { name: 'Translation', value: 'Translation' },
  //   { name: 'Writing', value: 'Writing' },
  //   { name: 'Marketing', value: 'Marketing' },
  //   { name: 'Community', value: 'Community' },
  //   { name: 'Product', value: 'Product' },
  //   { name: 'Research', value: 'Research' },
];

const route = useRoute();
const remainingTime = ref(0);

// Function to start the timer
const startTimer = () => {
  if (remainingTime.value === 0) {
    remainingTime.value = 60; // Set the timer to 60 seconds
    const timerInterval = setInterval(() => {
      remainingTime.value -= 1;
      if (remainingTime.value === 0) {
        clearInterval(timerInterval); // Clear the timer when it reaches 0
      }
    }, 1000); // Update the timer every 1000 milliseconds (1 second)
  }
};
const selectedTab = computed(() => {
  if (route.name === 'Profile Setting') return 0;
  if (route.name === 'Notify Setting') return 1;
  return null;
});

const addPlatform = () => {
  state.userInfo.customizeLink.push({
    name: '',
    url: '',
  });
};
const delPlatform = (index) => {
  state.userInfo.customizeLink.splice(index, 1);
};

const handleEmailVerification = async () => {
  if (!state.editNotifEmail && state.userInfo.isEmailVerified) {
    state.editNotifEmail = true;
    return;
  }
  if (
    maybeValidEmail(state.userInfo.notificationEmail) &&
    remainingTime.value === 0
  )
    try {
      const res = await sendEmail(state.userInfo.notificationEmail);
      startTimer();
      state.sentVerif = true;
      notify({
        type: 'success',
        text: 'Email sent successfully.',
        duration: 5000,
      });
    } catch (e) {
      notify({
        type: 'error',
        text: e.message,
        duration: 5000,
      });
    }
};
const handleNotifFollow = async (item) => {
  try {
    const res = await notifFollow(
      state.currNotifType === 0 ? 'dao' : 'member',
      state.currNotifType === 0 ? item.daoId : item.address,
    );
    loadNotif();
    notify({
      type: 'success',
      text: 'Updated Notification List',
    });
  } catch (e) {
    notify({
      type: 'error',
      text: e.message,
    });
    loadNotif();
  }
};
const selectFile = () => {
  if (state.loading) {
    return;
  }
  fileInput.value.click();
};

function maybeValidEmail(email) {
  if (email) return /^\S+@\S+\.\S+$/.test(email);
  else {
    return false;
  }
}
const doUpload = async (e) => {
  const [file] = e.target.files;

  if (!file) {
    return;
  }

  state.loading = true;
  try {
    const res = await uploadImg(file);
    state.userInfo.bannerUrl = res;
  } catch (error) {
    notify({
      type: 'error',
      text: error.message,
      duration: 5000,
    });
  }
  state.loading = false;
};
const updateTab = (i) => {
  if (i === 0) {
    router.push('/settings/profile');
  } else {
    router.push('/settings/notify');
  }
};
const handleNotifTypeUpdate = (i) => {
  state.currNotifType = i;
};
const handleEmailVerifyClose = () => {
  state.openVerifyEmailDialog = false;
};
const handleEmailResend = async () => {
  try {
    const res = await sendEmail();

    notify({
      type: 'success',
      text: 'Email resent successfully.',
      duration: 5000,
    });
  } catch (e) {
    notify({
      type: 'error',
      text: e.message,
      duration: 5000,
    });
  }
};
const canSave = computed(() => !isEqual(state.originalInfo, state.userInfo));
const doSave = async () => {
  if (canSave.value) {
    try {
      const temp = state.userInfo.customizeLink.map((x, i) => {
        console.log(x.name, x.url, !!x.name && !!x.url);
        if (!!x.name && !!x.url) return x;
        else {
          return null;
        }
      });

      state.userInfo.customizeLink = temp.filter((x) => !!x);

      const res = await updateProfile(state.userInfo);

      notify({
        type: 'success',
        text: 'Updated Profile Successfully',
        duration: 5000,
      });
      if (back) {
        router.back();
      }
      loadData();
      loadNotif();
      // let isValidEmail = true;
      // if (state.userInfo.email !== '' && state.userInfo.email)
      //   isValidEmail = maybeValidEmail(state.userInfo.email);
      // if (isValidEmail) {

      // } else {
      //   notify({
      //     type: 'error',
      //     text: 'Invalid Email. Please enter a valid email and try again.',
      //     duration: 5000,
      //   });
      // }
    } catch (e) {
      notify({
        type: 'error',
        text: e.message,
        duration: 5000,
      });
    }
  } else {
    return;
  }
};
const handleTwVerify = async () => {
  const res = await twProfileVerify(window.location.href);

  localStorage.setItem('USERINFO', JSON.stringify(state.userInfo));
  localStorage.setItem('TW_VERIFICATION', true);
  window.location.href = res;
};
const handleDialogOpen = (i) => {
  // if (state.userInfo.email && state.userInfo.isEmailVerified) {
  if (i === 0) {
    state.dialogType = 'dao';
    state.openDialog = true;
  } else if (i === 1) {
    state.dialogType = 'member';
    state.openDialog = true;
  }
  // } else {
  //   state.openVerifyEmailDialog = true;
  // }
};
const handleClose = () => {
  loadNotif();
  state.openDialog = false;
};
const handleNotifDialogOpen = (i, item) => {
  if (i === 0) {
    state.NotifType = 'dao';
    state.openNotifDialog = true;
    state.NotifItem = item;
  } else if (i === 1) {
    state.NotifType = 'member';
    state.openNotifDialog = true;
    state.NotifItem = item;
  }
};
const handleNotifClose = () => {
  loadData();
  loadNotif();
  state.openNotifDialog = false;
};

const loadData = async () => {
  const res = await getProfile();

  state.userInfo = res;
  state.origEmail = res.notificationEmail;
  state.isEmailVerified = res.isEmailVerified;
  if (res.twitter) {
    state.twitter = res.twitter.replace('https://twitter.com/', '');
  }
  if (state.userInfo.customizeLink) {
    state.userInfo.customizeLink =
      state.userInfo?.customizeLink == 0
        ? [
            {
              name: '',
              url: '',
            },
          ]
        : state.userInfo.customizeLink;
  } else {
    state.userInfo.customizeLink = [
      {
        name: '',
        url: '',
      },
    ];
  }
  console.log(res, state.userInfo);
  const isTwitterVerify = localStorage.getItem('TW_VERIFICATION');
  let existingData = localStorage.getItem('USERINFO');
  if (existingData) {
    existingData = JSON.parse(existingData);
    existingData.twitter = state.userInfo.twitter;
  }
  localStorage.removeItem('TW_VERIFICATION');
  localStorage.removeItem('USERINFO');

  if (isTwitterVerify) state.userInfo = existingData;

  state.originalInfo = cloneDeep(state.userInfo);
};
const loadNotif = async () => {
  const res = await getNotifList();

  state.notifList = res;
};
onMounted(() => {
  loadData();
  loadNotif();
  watch(
    () => userInfo.value.address,
    () => window.location.reload(),
  );
  watch(
    () => route.name,
    () => {
      loadData();
      loadNotif();
    },
  );

  watch(
    () => state.userInfo.notificationEmail,
    () => {
      if (state.origEmail !== state.userInfo.notificationEmail) {
        state.isEmailVerified = false;
      } else {
        state.isEmailVerified = true;
      }
    },
  );
});
</script>
<style>
.multiselect {
  --ms-bg: #121416ff;
  --ms-border-color: #ffffff26;
  --ms-dropdown-bg: #2a2e34;
  --ms-option-bg-pointed: #ffffff0d;
  --ms-option-color-pointed: #ffffff;
  --ms-tag-bg: #ffffff1a;
  --ms-option-bg-disabled: #2a2e34;
  --ms-option-color-disabled: rgba(255, 255, 255, 0.4);
  --ms-option-bg-selected: #ffffff0d;
  --ms-option-bg-selected-pointed: #ffffff0d;
  --ms-dropdown-border-width: 0px;
  --ms-tag-font-weight: 400;
  --ms-tag-font-size: 12px;
  --ms-option-font-size: 16px;
}
.multiselect-tags-search-wrapper input {
  background-color: #121416ff;
}
.multiselect.is-active {
  box-shadow: none !important;
}
.multiselect-dropdown {
  /* max-height: max-content !important; */
  overflow-y: auto !important;
}
.multiselect-option.is-selected {
  font-weight: 400;
}
</style>
<style src="@vueform/multiselect/themes/default.css"></style>
